import { useCallback } from 'react';
import { PaywallEvent } from './events';
import { AnalyticsEvent } from './schema';

/**
 * Hook for tracking self-pay analytics events.
 * All track functions are no-ops; callers retain the same API for compatibility.
 */
export function useTrackEvent() {
  const trackEvent = useCallback(async (
    _event: PaywallEvent | string,
    _properties: Partial<AnalyticsEvent> = {},
    _options?: {
      overrideUserId?: string;
      overrideValue?: string;
    }
  ) => {
    // no-op
  }, []);

  const trackSignUp = useCallback((_profile?: any, _usage?: number, _billingStatus?: string) => {
    // no-op
  }, []);

  const trackSignIn = useCallback((_profile?: any, _usage?: number, _billingStatus?: string) => {
    // no-op
  }, []);

  const trackUsageLimitReached = useCallback((
    _profile?: any,
    _usage?: number,
    _billingStatus?: string
  ) => {
    // no-op
  }, []);

  const trackPaywallDisplayed = useCallback((
    _triggerType?: string,
    _profile?: any,
    _usage?: number,
    _billingStatus?: string
  ) => {
    // no-op
  }, []);

  const trackUpgradeInitiated = useCallback((
    _triggerType?: string,
    _profile?: any,
    _usage?: number,
    _billingStatus?: string
  ) => {
    // no-op
  }, []);

  const trackCheckoutStarted = useCallback((
    _triggerType?: string,
    _profile?: any,
    _usage?: number,
    _billingStatus?: string
  ) => {
    // no-op
  }, []);

  const trackLimitAlertUpgradeClicked = useCallback((
    _profile?: any,
    _usage?: number,
    _billingStatus?: string
  ) => {
    // no-op
  }, []);

  const trackHeaderUpgradeClicked = useCallback((_profile?: any, _usage?: number, _billingStatus?: string) => {
    // no-op
  }, []);

  const trackBillingUpgradeClicked = useCallback((_profile?: any, _usage?: number, _billingStatus?: string) => {
    // no-op
  }, []);

  const trackStandalonePageView = useCallback((_anonymousId: string) => {
    // no-op
  }, []);

  const trackQuestionAsk = useCallback(() => {
    // no-op
  }, []);

  const trackDailyLimitReached = useCallback(() => {
    // no-op
  }, []);

  const trackLimitDemoClick = useCallback(() => {
    // no-op
  }, []);

  const trackStandaloneDemoClick = useCallback((_anonymousId: string) => {
    // no-op
  }, []);

  const trackStandaloneSigninClick = useCallback(() => {
    // no-op
  }, []);

  const trackStandaloneSignupClick = useCallback(() => {
    // no-op
  }, []);

  const trackStandaloneModalDemoClick = useCallback((_anonymousId: string) => {
    // no-op
  }, []);

  const trackStandaloneActive = useCallback(() => {
    // no-op
  }, []);

  const trackSaspGateSignupClick = useCallback(() => {
    // no-op
  }, []);

  const trackSaspGateSigninClick = useCallback(() => {
    // no-op
  }, []);

  const trackSaspCustomizeContactClick = useCallback(() => {
    // no-op
  }, []);

  const trackSaspUserSignedUp = useCallback((_userId: string) => {
    // no-op
  }, []);

  const trackSaspUserSignedIn = useCallback((_userId: string) => {
    // no-op
  }, []);

  return {
    trackEvent,
    trackSignUp,
    trackSignIn,
    trackUsageLimitReached,
    trackPaywallDisplayed,
    trackUpgradeInitiated,
    trackCheckoutStarted,
    trackLimitAlertUpgradeClicked,
    trackHeaderUpgradeClicked,
    trackBillingUpgradeClicked,
    trackStandalonePageView,
    trackQuestionAsk,
    trackDailyLimitReached,
    trackLimitDemoClick,
    trackStandaloneDemoClick,
    trackStandaloneSigninClick,
    trackStandaloneSignupClick,
    trackStandaloneModalDemoClick,
    trackStandaloneActive,
    trackSaspCustomizeContactClick,
    trackSaspGateSignupClick,
    trackSaspGateSigninClick,
    trackSaspUserSignedUp,
    trackSaspUserSignedIn,
  };
}
